var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "db_assets",
    transform: "translate(-1015.000000, -551.000000)",
    fill: "#1B1B1B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modal-scroll",
    transform: "translate(452.000000, 528.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/close",
    transform: "translate(556.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9998,7 L24.9998,8.414 L19.5358,13.878 C18.3658,15.048 18.3658,16.951 19.5358,18.121 L19.5358,18.121 L24.9998,23.586 L24.9998,25 L23.5858,25 L18.1218,19.535 C16.1718,17.586 16.1718,14.414 18.1218,12.464 L18.1218,12.464 L23.5858,7 L24.9998,7 Z M8.4139,7 L13.8789,12.464 C15.8289,14.414 15.8289,17.586 13.8789,19.535 L13.8789,19.535 L8.4139,25 L6.9999,25 L6.9999,23.586 L12.4649,18.121 C13.6339,16.951 13.6339,15.048 12.4649,13.878 L12.4649,13.878 L6.9999,8.414 L6.9999,7 L8.4139,7 Z",
    id: "icon"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.031876b6174ee57012af71888fba56a6.svg";
export { ForwardRef as ReactComponent };